import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  updateStripePaymentMethodFailure,
  updateStripePaymentMethodSuccess
} from "../slices/features/stripePaymentMethod";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* updateStripePaymentMethodSaga(action: any) {
  const { payload } = action;
  const { id, paymentMethodId, data } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.updateStripePaymentMethod,
      baseUrl,
      id,
      paymentMethodId,
      data
    );

    yield put(updateStripePaymentMethodSuccess({ ...response }));

    let paymentMethodData = {};
    if (response.data) {
      paymentMethodData = response.data;
    }

    payload?.cbSuccess && payload?.cbSuccess(paymentMethodData);
  } catch (error: any) {
    const { statusCode, statusText } = error;
    yield put(updateStripePaymentMethodFailure({ statusCode, statusText }));
  }
}

export function* watchUpdateStripePaymentMethod() {
  yield takeLatest(
    RequestTypes.UPDATE_STRIPE_PAYMENT_METHOD_REQUEST,
    updateStripePaymentMethodSaga
  );
}
